import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';
import { VersionId, SynonymPK, GroupName, EntryId } from './searchApiConstants';

const headers = {
  'Content-Type': 'application/json',
};

export const getSearchReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-search`,
  method: HTTPVerbs.GET,
  headers,
  retries: 2,
  retryOnStatus: [500, 503, 504],
};

export const getContentSearchReqObj: RequestOptions = {
  url: `/egw/contentsearchproxy/rest/v1/content/search`,
  method: HTTPVerbs.POST,
  headers,
  retries: 0,
};

export const getSynonymGroupsReqObj = (amwayCountry?: string, amwayLanguage?: string): RequestOptions => ({
  url: `/comsearchas/${VersionId}/products-index/dictionary/synonym`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
    'Accept-Language': amwayLanguage || '%',
    'X-Amway-Country': amwayCountry || '%',
  },
  retries: 0,
});

export const getCreateSynonymGroupReqObj = (amwayCountry: string, amwayLanguage: string): RequestOptions => ({
  url: `/comsearchas/${VersionId}/products-index/dictionary/synonyms`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
    'Accept-Language': amwayLanguage,
    'X-Amway-Country': amwayCountry,
  },
  retries: 0,
});

export const getSynonymReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-index/dictionary/synonym/${SynonymPK}`,
  method: HTTPVerbs.GET,
  headers,
  retries: 0,
};

export const getSynonymByGroupNameReqObj = (amwayCountry?: string, amwayLanguage?: string): RequestOptions => ({
  url: `/comsearchas/${VersionId}/products-index/dictionary/syngroup/${GroupName}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
    'Accept-Language': amwayLanguage || '%',
    'X-Amway-Country': amwayCountry || '%',
  },
  retries: 0,
});

export const deleteSynonymGroupReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-index/dictionary/synonym/${SynonymPK}`,
  method: HTTPVerbs.DELETE,
  headers,
  retries: 0,
};

export const getUpdateSynonymGroupReqObj = (amwayCountry: string, amwayLanguage: string): RequestOptions => ({
  url: `/comsearchas/${VersionId}/products-index/dictionary/synonym/${SynonymPK}`,
  method: HTTPVerbs.PATCH,
  headers: {
    ...headers,
    'Accept-Language': amwayLanguage,
    'X-Amway-Country': amwayCountry,
  },
  retries: 0,
});

export const updateIndexReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-index/index`,
  method: HTTPVerbs.PUT,
  headers,
  retries: 0,
};

export const getIndexHistoryEntriesReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-index/index`,
  method: HTTPVerbs.GET,
  headers,
  retries: 0,
};

export const getLowQualityResultsReqObj = (language?: string): RequestOptions => ({
  url: `/comsearchas/${VersionId}/products-search/low-quality-results`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
    'Accept-Language': language ?? '%',
  },
  retries: 0,
});

export const lowQualityResultEntryReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-search/low-quality-result/${EntryId}`,
  method: HTTPVerbs.GET,
  headers,
  retries: 0,
};

export const updateLowQualityResultEntryReqObj: RequestOptions = {
  url: `/comsearchas/${VersionId}/products-search/low-quality-result/${EntryId}`,
  method: HTTPVerbs.PATCH,
  headers,
  retries: 0,
};
